import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import { animated } from 'react-spring'

import { useHooks } from './methods'

import { ReactComponent as Arrow } from '@/svg/logo_arrow.svg'

import Container from './style'
const AnimatedContainer = animated(Container)

interface Props {
  title: string
  children: ReactNode | string
  style?: CSSProperties
  className?: string
  id?: string
}

function ExpandableContent({
  id,
  children,
  title,
  className,
  style,
}: Props): ReactElement {
  const {
    titleRef,
    childRef,
    arrowSpring,
    containerSpring,
    handleClick,
    childSpring,
    titleSpring,
  } = useHooks()

  return (
    <AnimatedContainer
      id={id}
      className={className}
      style={{
        ...style,
        ...containerSpring,
      }}
    >
      <animated.section
        ref={titleRef}
        onClick={handleClick}
        style={titleSpring}
      >
        <h1>{title}</h1>
        <animated.figure style={arrowSpring}>
          <Arrow />
        </animated.figure>
      </animated.section>
      <animated.article
        className="widget-background"
        ref={childRef}
        style={childSpring}
      >
        {children}
      </animated.article>
    </AnimatedContainer>
  )
}

ExpandableContent.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

ExpandableContent.defaultProps = {
  className: '',
}

export default memo(ExpandableContent)
